











































































import Enterprise from '@/datatypes/enterprise';
import User from '@/datatypes/user';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    enterprises: new Array<Enterprise>(),
    user: new User({}),
    errorMessage: '',
    enterpriseSearch: {
      term: '' as string | (string | null)[],
      kind: '' as string,
    },
    nextPointer: undefined as string | undefined,
    enterpriseService: new EnterpriseService(),
    totalCount: 0,
  }),

  components: {
    SnackbarMessageHandler,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  computed: {
    kinds() {
      return this.user.kindHash.map(
        (item) => [item.kind, item.name],
      );
    },
    hasNext() {
      return typeof this.nextPointer === 'string';
    },
  },

  methods: {
    routeChanged() {
      this.getEnterprises();
    },

    getQueryOptions() {
      if (
        (typeof this.enterpriseSearch.kind !== 'undefined')
        && (this.enterpriseSearch.kind !== '')
      ) {
        return {
          term: this.enterpriseSearch.term,
          kind: parseInt(this.enterpriseSearch.kind, 10),
          next: this.nextPointer,
        };
      }

      return {
        term: this.enterpriseSearch.term,
        kind: undefined,
        next: this.nextPointer,
      };
    },

    concatEnterpriseResponse(data: Enterprise[]) {
      this.enterprises = this.enterprises.concat(data);
    },

    getEnterprises() {
      this.enterpriseService.getEnterprises(this.getQueryOptions()).then((response) => {
        this.concatEnterpriseResponse(response.data.map((data) => new Enterprise(data)));
        this.nextPointer = undefined;

        if (this.enterprises.length === 0) {
          this.errorMessage = 'No businesses found.';
        }

        if (response.headers.total_count) {
          this.totalCount = response.headers.total_count;
        } else {
          this.totalCount = 0;
        }

        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        }
      });
    },

    requestNextPage() {
      this.getEnterprises();
    },

    searchEnterprise() {
      this.enterprises = [];
      this.nextPointer = undefined;
      this.getEnterprises();
    },
  },
});
